import {useContext} from "react";
import {Navigate, Outlet} from "react-router-dom";

import useWebSocket from "../hooks/use-web-socket";
import {AppStoreContext} from "../store/app-store.ts";

const ProtectedRoute = () => {
    useWebSocket();
    const { context } = useContext(AppStoreContext);

    // Check if context state is empty on refresh
    return Object.keys(context).length !== 0 ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
